import { ScrollTop } from '@/components/element/ScrollTop';
import { Activities } from '@/components/features/tasks/sales_order_contract/Activities';
import { Comments } from '@/components/features/tasks/sales_order_contract/Comments';
import { ProjectInfo } from '@/components/features/tasks/sales_order_contract/ProjectInfo';
import { TaskFiles } from '@/components/features/tasks/sales_order_contract/TaskFiles';
import { TaskProgress } from '@/components/features/tasks/sales_order_contract/TaskProgress';
import { TaskSummary } from '@/components/features/tasks/sales_order_contract/TaskSummary';
import { ToDoList } from '@/components/features/tasks/sales_order_contract/ToDoList';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useEffect } from 'react';

export const BackofficeSalesOrderContractTask = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_ } = useCurrentWorkspace();
  useEffect(() => setTitle('契約申請（売上）タスク詳細'), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `契約申請（売上）タスク一覧`,
          path: `/w/${_w_!.identifier}/backoffice/sales_order_contract_tasks`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="row mb-4">
          <div className="col-12 col-lg-7">
            <ToDoList />

            <TaskFiles />

            <Comments />
          </div>
          <div className="col-12 col-lg-5">
            <TaskSummary />

            <TaskProgress />

            <ProjectInfo />

            <Activities />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
